const STOP_WORDS = new Set('a an the and or of for to in with from please need needs want wanted required requirement requirements product products album albums photo photos image images shakti'.split(' '));
const WORD_FORMS = { shelves: 'shelf', shelving: 'shelf', racks: 'rack', displays: 'display', cabinets: 'cabinet', counters: 'counter', trolleys: 'trolley' };

export function albumKeywords(text = '') {
  return [...new Set((text.normalize('NFKD').toLowerCase().replace(/[\u0300-\u036f]/g, '').match(/[a-z0-9]+/g) || [])
    .filter(word => word.length > 2 && !STOP_WORDS.has(word))
    .map(word => WORD_FORMS[word] || word))];
}

// Deterministic name matching only: no external AI, no invented relevance.
export function rankAlbums(folders, description = '') {
  const keywords = albumKeywords(description || '');
  return folders.map((folder, index) => {
    const nameWords = new Set(albumKeywords(folder.name || ''));
    const matchedKeywords = keywords.filter(word => nameWords.has(word));
    return { ...folder, matchedKeywords, score: matchedKeywords.length, originalIndex: index };
  }).sort((a, b) => b.score - a.score || a.originalIndex - b.originalIndex)
    .map((folder, index) => ({ ...folder, recommended: folder.score > 0 && index < 3 }));
}